module.exports = __webpack_public_path__ + "static/media/IBM聊天机器人（英语，加载慢）.4632920e.png";